import { defineStore } from "pinia"
import { ref } from "vue"
import { toast } from "vue3-toastify"
import { usePermissionsStore } from "./permissions"

export interface User {
  id: string;
  name: string;
  email: string;
  roleTitle: string;
  profilePic?: string;
}

export const useAuthStore = defineStore("auth", () => {
  const token = ref<string | null>(localStorage.getItem("token"))
  const user = ref<User | null>(JSON.parse(localStorage.getItem("user") || "null"))

  function setToken(newToken: string) {
    token.value = newToken
    localStorage.setItem("token", newToken)
  }

  function setUser(newUser: User) {
    user.value = newUser
    localStorage.setItem("user", JSON.stringify(newUser))
  }

  function clearUser() {
    user.value = null
    localStorage.removeItem("user")
  }

  function clearToken() {
    token.value = null
    localStorage.removeItem("token")
    
    // Clear user and permissions as well
    clearUser()
    const permissionsStore = usePermissionsStore()
    permissionsStore.clearPermissions()
  }

  function logout(showSessionExpired: boolean = false) {
    clearToken()
    if (showSessionExpired) {
      toast.error("Your session has expired. Please log in again.", {
        autoClose: 3000,
        position: toast.POSITION.TOP_CENTER,
      })
      // Small delay to let the toast be seen before redirecting
      setTimeout(() => {
        window.location.href = "/login"
      }, 1000)
    } else {
      window.location.href = "/login"
    }
  }

  return {
    token,
    user,
    setToken,
    setUser,
    clearUser,
    clearToken,
    logout
  }
})
